import { render } from "./MyList.vue?vue&type=template&id=ade4847e"
import script from "./MyList.vue?vue&type=script&lang=js"
export * from "./MyList.vue?vue&type=script&lang=js"

import "./MyList.vue?vue&type=style&index=0&id=ade4847e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__